import { lazy } from "@bridgesplit/ui";

const CreateGroup = lazy(() => import("./CreateGroup"));
const GroupRolesAdmin = lazy(() => import("./GroupRolesAdmin"));

export { CreateGroup, GroupRolesAdmin };

export * from "./form";
export * from "./permissions";
